import React from 'react';
import { MultilingualWidget } from 'volto-multilingual-widget';
import { ArrayWidget } from '@plone/volto/components';
import { SizeWidget, ColorListWidget } from 'iovisit-theme/components';
import { VocabularyIconsWidget } from 'volto-vocabulary-icons-widget';

export const IoVisitWidgets = (config) => {
  config.widgets.id.cookie_consent_configuration = MultilingualWidget();
  config.widgets.id.thematic_areas = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.cuisine_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );

  config.widgets.id.custom_transports = MultilingualWidget(
    (props) => <VocabularyIconsWidget {...props} wrapped={false} />,
    [],
  );
  config.widgets.id.restaurant_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.accomodation_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.suited_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );
  config.widgets.id.service_types = MultilingualWidget(
    (props) => <ArrayWidget {...props} creatable={true} wrapped={false} />,
    [],
  );

  //(props) => <VocabularyWidget {...props} wrapped={false} />, //per quelli di tipo chiave-valore
  config.widgets.type.size = SizeWidget;
  config.widgets.widget.color_list = ColorListWidget;
};
